import React from "react";
import PropTypes from "prop-types";
import { AlertContainer, AlertIcon, AlertMessage } from "./styled";
import { Icon, ICONS } from "../../Icons";

const iconNames = {
  success: ICONS.check,
  info: ICONS.info,
  warning: ICONS.info,
  error: ICONS.information
};

/**
 * Alert component for displaying feedback messages with severity icons.
 *
 * @component
 * @param {Object} props - Component props
 * @param {'success'|'info'|'warning'|'error'} props.severity - The severity level of the alert
 * @param {React.ReactNode} props.children - The alert message content
 * @returns {React.ReactElement} The rendered Alert component
 */
export const Alert = ({ severity, children }) => {
  const iconName = iconNames[severity];

  return (
    <AlertContainer severity={severity} role="alert">
      <AlertIcon>
        {iconName ? (
          <Icon name={iconName} alt={severity} />
        ) : (
          <span
            data-testid="alert-icon-fallback"
            style={{ border: "1px solid red", display: "inline-block", width: 22, height: 22 }}
          />
        )}
      </AlertIcon>
      <AlertMessage>{children}</AlertMessage>
    </AlertContainer>
  );
};

Alert.propTypes = {
  severity: PropTypes.oneOf(["success", "info", "warning", "error"]).isRequired,
  children: PropTypes.node.isRequired
};
